import * as calculatorConfig from '@/config/base-config.json';
import { FINANCING_YEAR_65, FINANCING_YEAR_75, FinancingLoanType } from '@/constants/common';
import { generateSliderSteps } from '@/utils/generateSliderSteps';

export const MAX_PROFILES = 4;

export const PRIVATE_TDSR_LABEL = {
  Age: 'Age',
  EnterAge: 'Enter age',
  AvailableCash: 'Available Cash',
  AvailableCpfOa: 'Available CPF OA',
  IncomeAssessment: 'Income Assessment',
  MonthlyFixedIncome: 'Monthly Fixed Income',
  MonthlyVariableIncome: 'Monthly Variable Income',
  OtherMonthlyIncome: 'Other Monthly Income',
  TotalMonthlyAssessableIncome: 'Total Monthly Assessable Income',
  DebtAssessment: 'Debt Assessment',
  NumberofResidentialLoans: 'Number of Residential Loans',
  MonthlyResidentialInstalment: 'Monthly Residential Instalment',
  MonthlyCarLoanInstalment: 'Monthly Car Loan Instalment',
  OtherMonthlyDebt: 'Other Monthly Debt',
  TotalMonthlyDebtAssessment: 'Total Monthly Debt Assessment',
  TDSRVariables: 'Total Debt Service Ratio(TDSR) Variables',
  LoanTenure: 'Loan Tenure (Years)',
  MediumTermInterestRate: 'Medium-Term Interest Rate',
  LoanToValue: 'Loan-to-Value',
  Total: 'Total',
  MaximumPurchasePrice: 'Maximum Purchase Price',
  BasedOnIncome: 'Based on Income',
  BasedOnAvailableCashAndCPF: 'Based on Available Cash & CPF',
  PossiblePurchasePrice: 'Possible Purchase Price',
  Cash: 'Cash',
  CpfOaPerCash: 'CPF OA / Cash',
  LoanAmount: 'Loan Amount',
  Lowest: 'Lowest',
  Highest: 'Highest',
  PlusAddProfile: '+ Add Profile',
  AdditionalProfile: 'Additional Profile',
};

export const CHART_LABELS = [
  PRIVATE_TDSR_LABEL.Cash,
  PRIVATE_TDSR_LABEL.CpfOaPerCash,
  PRIVATE_TDSR_LABEL.LoanAmount,
];

export const CHART_COLORS = ['#F8CB59', '#9475EB', '#F25A73'];

export enum NumberOfResidentialLoans {
  NoLoan = '0',
  FirstLoan = '1',
  SecondLoan = '2',
}

export const NUMBER_OF_RESIDENTIAL_LOANS = {
  LIST: Object.values(NumberOfResidentialLoans).map((value) => {
    return {
      value,
      label: value === NumberOfResidentialLoans.SecondLoan ? `${value}+` : value,
    };
  }),
};

export const MEDIUM_TERM_INTEREST_RATE = {
  LABEL_INPUTS: generateSliderSteps(
    calculatorConfig.medium_term_interest_rate.min,
    calculatorConfig.medium_term_interest_rate.max,
    0.2,
  ),
  DEFAULT: calculatorConfig.medium_term_interest_rate.default,
  MIN: calculatorConfig.medium_term_interest_rate.min,
  MAX: calculatorConfig.medium_term_interest_rate.max,
  STEP: 0.01,
};

export const DEFAULT_LOAN_DETAILS_AGE_65 = {
  LOAN_TYPE: FinancingLoanType.sixtyFiveYearLoan,
  LOAN_TENURE_MAX: FINANCING_YEAR_65.LOAN_TENURE.MAX,
  LOAN_TENURE_LABEL: FINANCING_YEAR_65.LOAN_TENURE.SLIDER_LABELS,
  LOAN_TO_VALUE_MAX: FINANCING_YEAR_65.LTV.MAX,
  LOAN_TO_VALUE_LABEL: FINANCING_YEAR_65.LTV.SLIDER_LABELS,
};

export const DEFAULT_LOAN_DETAILS_AGE_75 = {
  LOAN_TYPE: FinancingLoanType.seventyFiveYearLoan,
  LOAN_TENURE_MAX: FINANCING_YEAR_75.LOAN_TENURE.MAX,
  LOAN_TENURE_LABEL: FINANCING_YEAR_75.LOAN_TENURE.SLIDER_LABELS,
  LOAN_TO_VALUE_MAX: FINANCING_YEAR_75.LTV.MAX,
  LOAN_TO_VALUE_LABEL: FINANCING_YEAR_75.LTV.SLIDER_LABELS,
};

export type Profile = {
  name: string;
  age: string;
  availableCash: string;
  availableCPFInOA: string;
  monthlyFixedIncome: string;
  monthlyVariableIncome: string;
  monthlyOtherIncome: string;
  numberOfResidentialLoan: NumberOfResidentialLoans;
  monthlyResidentialInstalment: string;
  monthlyCarLoanInstalment: string;
  monthlyOtherDebt: string;
};
